import { render, nothing, html } from "lit-html";
import connect from "../../../shared/data-store/connect";
import { store } from "./DataStore";

customElements.define(
	"esc-hotel-list-filter-counter",
	class extends connect(HTMLElement, store) {
		update(state, { filtersCount }) {
			const category = this.getAttribute("category");
			filtersCount =
				category !== null ? state.filters[category].length : filtersCount;

			if (filtersCount > 0) {
				this.classList.add("counter-badge", "counter-badge--green");
			} else {
				this.classList.remove("counter-badge", "counter-badge--green");
			}

			const template =
				filtersCount > 0
					? html`<span>${filtersCount}</span>`
					: this.hasAttribute("show-icon")
						? html`<i class="fa fa-sliders"></i>`
						: nothing;
			render(template, this);
		}
	},
);
